module.exports = __webpack_public_path__ + "img/17.5d7633e1.jpg";